<template>
  <div class="page">
    <div class="title">{{msg.msgTitle}}</div>
    <div class="title-sub">汽车之家招聘 {{msg.createTimeShow}}</div>
    <div class="body">
      <div class="content">
        <p v-for="(item,i) in msg.msgCotnet" :key="'c'+i">{{item}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "../utils/Utils";
import {Toast} from "vant";
import Request from "../utils/Request";
import Urls from "../utils/Urls";
import moment from 'moment';
export default {
  name: "Msg",
  data() {
    return {
      app:"",
      loading:false,
      msg: {
      },
    };
  },
  mounted: function() {
    this.app=Utils.getApp();
    this.getPostion();
  },
  methods: {
    getPostion() {
      let that = this;
      this.loading = true;
      Toast.loading({
        duration: 0,
        forbidClick: true,
      });
      Request.request(Urls.getMsg, {id: this.$route.query.id}).then(data => {
        that.loading = false;
        Toast.clear();
        if (data) {
          if(data.msg)
          {
            data.msg=JSON.parse(data.msg);
            if(data.msg && data.msg.content)
            {
              data.msgCotnet=data.msg.content.split('\n');
            }
          }
          data.createTimeShow=moment(data.createTime).format('YYYY-MM-DD HH:mm');
          that.msg = data;
        }
      });
    }
  }
}
</script>

<style scoped>
.page{
  margin:0 20px 20px;
}
.title{

  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #20253F;
  line-height: 22px;
  font-weight: 500;

  margin-top: 16px;
}
.title-sub{

  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #6F778F;
  line-height: 16px;
  font-weight: 400;

  margin-top: 8px;
}
.body{
  margin-top: 37px;
  padding: 16px;
  border-radius: 8px;
  background-color: #005cff;
}
.content{
  border-radius: 8px;
  background-color: #FFFFFF;
  padding: 16px;


  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #20253F;
  line-height: 22px;
  font-weight: 400;

  word-break: break-all;
}
.content p{
  margin: 0;
  padding: 0;
}
/*.content p+p{*/
/*  margin-top: 4px;*/
/*}*/
</style>